import { render, staticRenderFns } from "./WorkFunctionRename.vue?vue&type=template&id=5c8228ee&"
import script from "./WorkFunctionRename.vue?vue&type=script&lang=js&"
export * from "./WorkFunctionRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports